import React, { useEffect, useState } from 'react';
import ModalAlert from '../components/ModalAlert/ModalAlert'
import WithPreloader from '../HOC/WithPreloader'
import { notify } from '../helpers/notify'
import { confirmSeafarer } from '../api/postApi'

const AcceptRejectSeafarer = () => {
  const [isActionSuccess, setIsActionSuccess] = useState(null);
  const [isActionText, setIsActionText] = useState(null);
  const [error, setError] = useState('Something went wrong. Try again.');

  const getSeafarerActionQueries = () => {
    const searchUrl = new URL(window.location.href);
    const secret = decodeURIComponent(searchUrl.searchParams.get('secret'));

    return {
      secret,
    };
  };

  useEffect(() => {
    const { secret } = getSeafarerActionQueries();
    confirmSeafarer({secret})
      .then((data) => {
        setIsActionSuccess(data.status);
        setIsActionText(data.action);
      })
      .catch(({ error }) => {
        setError(error.message);
        setIsActionSuccess(false);
        notify.error(error.message);
      });
  }, []);

  return (
    <div className="page" style={{ height: '100%' }}>
      <main>
        <WithPreloader
          component={ModalAlert}
          isActive={isActionSuccess === null}
          size={120}
          type="magnifier"
          isOk={isActionSuccess}
          title={isActionSuccess ? 'Success!' : 'Oops..'}
          content={isActionSuccess ? `Action ${isActionText} completed successfully.` : error}
        />
      </main>
    </div>
  );
};

export default AcceptRejectSeafarer;
